import { GenIcon } from '../helpers/IconBase.es.js';

const ListOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M4.66667 4.0002H15.3333C15.5101 4.0002 15.6797 3.92996 15.8047 3.80494C15.9298 3.67992 16 3.51035 16 3.33354C16 3.15672 15.9298 2.98716 15.8047 2.86213C15.6797 2.73711 15.5101 2.66687 15.3333 2.66687H4.66667C4.48986 2.66687 4.32029 2.73711 4.19526 2.86213C4.07024 2.98716 4 3.15672 4 3.33354C4 3.51035 4.07024 3.67992 4.19526 3.80494C4.32029 3.92996 4.48986 4.0002 4.66667 4.0002Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.3333 7.33313H4.66667C4.48986 7.33313 4.32029 7.40337 4.19526 7.52839C4.07024 7.65342 4 7.82299 4 7.9998C4 8.17661 4.07024 8.34618 4.19526 8.47121C4.32029 8.59623 4.48986 8.66647 4.66667 8.66647H15.3333C15.5101 8.66647 15.6797 8.59623 15.8047 8.47121C15.9298 8.34618 16 8.17661 16 7.9998C16 7.82299 15.9298 7.65342 15.8047 7.52839C15.6797 7.40337 15.5101 7.33313 15.3333 7.33313Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M15.3333 12H4.66667C4.48986 12 4.32029 12.0702 4.19526 12.1953C4.07024 12.3203 4 12.4899 4 12.6667C4 12.8435 4.07024 13.0131 4.19526 13.1381C4.32029 13.2631 4.48986 13.3333 4.66667 13.3333H15.3333C15.5101 13.3333 15.6797 13.2631 15.8047 13.1381C15.9298 13.0131 16 12.8435 16 12.6667C16 12.4899 15.9298 12.3203 15.8047 12.1953C15.6797 12.0702 15.5101 12 15.3333 12Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M1.33333 4.66666C2.06971 4.66666 2.66667 4.06971 2.66667 3.33333C2.66667 2.59695 2.06971 2 1.33333 2C0.596954 2 0 2.59695 0 3.33333C0 4.06971 0.596954 4.66666 1.33333 4.66666Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M1.33333 9.33353C2.06971 9.33353 2.66667 8.73658 2.66667 8.0002C2.66667 7.26382 2.06971 6.66687 1.33333 6.66687C0.596954 6.66687 0 7.26382 0 8.0002C0 8.73658 0.596954 9.33353 1.33333 9.33353Z",
          fill: "#434657"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M1.33333 13.9998C2.06971 13.9998 2.66667 13.4028 2.66667 12.6665C2.66667 11.9301 2.06971 11.3331 1.33333 11.3331C0.596954 11.3331 0 11.9301 0 12.6665C0 13.4028 0.596954 13.9998 1.33333 13.9998Z",
          fill: "#434657"
        }
      }
    ]
  })(props);
};

export { ListOutlined };
